import React from "react";

export const VersionPage = () => {
  return (
    <code className="d-none">{JSON.stringify({ _version: process.env.REACT_APP_VERSION })}</code>
  );
};
